import { LawyerLite, LawyerTiny } from './../../models/lawyers/lawyer';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TimesheetEntry, TimesheetExpense } from '../../models/timesheet/timesheetEntry';

@Component({
  selector: 'app-timesheet-entry-modal',
  templateUrl: './timesheet-entry-modal.component.html',
  styleUrls: ['./timesheet-entry-modal.component.scss']
})
export class TimesheetEntryModalComponent implements OnInit {

  public entry: TimesheetEntry;
  public expense: TimesheetExpense;
  fileLawyers: LawyerLite|LawyerTiny[];
  @ViewChild('timesheetEntryModal') modal;
  modalRef: NgbModalRef;

  @Output() submitExpense: EventEmitter<TimesheetExpense> = new EventEmitter<TimesheetExpense>();
  @Output() submitEntry: EventEmitter<TimesheetEntry> = new EventEmitter<TimesheetEntry>();


  constructor(private modalService: NgbModal) { }

  ngOnInit(): void {
  }

  openEntryForm(entry: TimesheetEntry, fileLawyers: LawyerLite|LawyerTiny[]) {
    this.expense = null;
    this.entry = entry;
    this.fileLawyers = fileLawyers;
    this.modalRef = this.modalService.open(this.modal, { centered: true, size: 'md' });
  }

  openExpenseForm(exp: TimesheetExpense) {
    this.entry = null;
    this.expense = exp;
    this.modalRef = this.modalService.open(this.modal, { centered: true, size: 'md' });

  }

  close() {
    this.modalRef.close();
  }

  onSubmitEntry(e) {
    console.log(e);
    this.submitEntry.emit(e);
    this.close();
  }

  onSubmitExpense(e) {
    this.submitExpense.emit(e);
    this.close();
  }

}
